<template>
  <div style="overflow: hidden;height:100%;">
    <el-container style="border: 1px solid #eee;overflow: hidden;height:100%;">
      <el-aside width="218px" class="left_nav_menus">
        <el-menu :default-active="activeIndex" @select="clickLeftMenu">
          <el-menu-item index="8"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 经销商大屏</el-menu-item
          >
          <el-menu-item index="1"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 任务总览</el-menu-item
          >
          <el-menu-item index="2"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 客户汇总</el-menu-item
          >
          <el-menu-item index="3"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 车系统计</el-menu-item
          >
          <el-menu-item index="4"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 线下客户统计</el-menu-item
          >
          <el-menu-item index="5"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 线上线索统计</el-menu-item
          >
          <el-menu-item index="6"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 签到统计</el-menu-item
          >
          <el-menu-item index="9"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 新媒体线索成交表</el-menu-item
          >
          <el-menu-item index="10"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 三大垂媒线索到店率</el-menu-item
          >
          <el-menu-item index="11"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 三大垂媒线索清洗时长</el-menu-item
          >
          <el-menu-item v-if="dealer && dealer.type === 1" index="12"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 王朝线索跟进明细表</el-menu-item
          >
          <el-menu-item v-if="dealer && dealer.type === 1" index="13"
            ><i
              class="fa fa-angle-double-right fa-fw fa-lg"
              aria-hidden="true"
            ></i
            >&nbsp; 王朝线索跟进统计表</el-menu-item
          >
        </el-menu>
      </el-aside>

      <el-container style="overflow-y:auto;overflow-x:hidden;">
        <div
          style="padding:20px;width:100%;overflow:hidden;box-sizing: border-box;"
        >
          <router-view></router-view>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// import Cookies from "js-cookie";
export default {
  data() {
    return {
      dealer: this.$common.getDealer(),
      isBoss: this.$common.isBoss(),
      activeIndex: "1",
      isAdmin: this.$common.getAdmin(),
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.path.startWith("/report/task")) {
        vm.activeIndex = "1";
      }
      if (to.path.startWith("/report/customer")) {
        vm.activeIndex = "2";
      }
      if (to.path.startWith("/report/series")) {
        vm.activeIndex = "3";
      }
      if (to.path.startWith("/report/storeCustomer")) {
        vm.activeIndex = "4";
      }
      if (to.path.startWith("/report/onlineClue")) {
        vm.activeIndex = "5";
      }
      if (to.path.startWith("/report/sign")) {
        vm.activeIndex = "6";
      }
      if (to.path.startWith("/report/bigScreen")) {
        vm.activeIndex = "8";
      }
      if (to.path.startWith("/report/newMediaClue")) {
        vm.activeIndex = "9";
      }
      if (to.path.startWith("/report/effectArrivalRate")) {
        vm.activeIndex = "10";
      }
      if (to.path.startWith("/report/effectArrivalClueCleaning")) {
        vm.activeIndex = "11";
      }
      if (to.path.startWith("/report/clueFollowDetails")) {
        vm.activeIndex = "12";
      }
      if (to.path.startWith("/report/clueFollowStatistics")) {
        vm.activeIndex = "13";
      }
    });
  },
  created() {},
  methods: {
    clickLeftMenu(index) {
      if (index == "1") {
        this.$router.push({
          path: "/report/task",
        });
      }
      if (index == "2") {
        this.$router.push({
          path: "/report/customer",
        });
      }
      if (index == "3") {
        this.$router.push({
          path: "/report/series",
        });
      }
      if (index == "4") {
        this.$router.push({
          path: "/report/storeCustomer",
        });
      }
      if (index == "5") {
        this.$router.push({
          path: "/report/onlineClue",
        });
      }
      if (index == "6") {
        this.$router.push({
          path: "/report/sign",
        });
      }
      if (index == "8") {
        this.$router.push({
          path: "/report/bigScreen",
        });
      }
      if (index == "9") {
        this.$router.push({
          path: "/report/newMediaClue",
        });
      }
      if (index == "10") {
        this.$router.push({
          path: "/report/effectArrivalRate",
        });
      }
      if (index == "11") {
        this.$router.push({
          path: "/report/effectArrivalClueCleaning",
        });
      }
      if (index == "12") {
        this.$router.push({
          path: "/report/clueFollowDetails",
        });
      }
      if (index == "13") {
        this.$router.push({
          path: "/report/clueFollowStatistics",
        });
      }
    },
  },
};
</script>

<style></style>
